import { render } from "./GroupbuyTipModal.vue?vue&type=template&id=25bf0a18&scoped=true"
import script from "./GroupbuyTipModal.vue?vue&type=script&lang=js"
export * from "./GroupbuyTipModal.vue?vue&type=script&lang=js"

import "./GroupbuyTipModal.vue?vue&type=style&index=0&id=25bf0a18&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bf0a18"]])

export default __exports__